export const toolsData = [
  // Text & Content Tools
  {
    id: 'word-counter',
    name: 'Word Counter',
    description: 'Count words, characters, sentences, and paragraphs in your text',
    icon: '📝',
    category: 'Text & Content',
    path: '/tools/word-counter',
    component: 'WordCounter'
  },
  {
    id: 'text-case-converter',
    name: 'Text Case Converter',
    description: 'Convert text to UPPERCASE, lowercase, Title Case, and more',
    icon: '🔄',
    category: 'Text & Content',
    path: '/tools/text-case-converter',
    component: 'TextCaseConverter'
  },
  {
    id: 'text-compare',
    name: 'Text Compare',
    description: 'Find differences between two texts line by line',
    icon: '🔍',
    category: 'Text & Content',
    path: '/tools/text-compare',
    component: 'TextCompare'
  },
  {
    id: 'lorem-ipsum',
    name: 'Lorem Ipsum Generator',
    description: 'Generate placeholder text for your designs',
    icon: '📄',
    category: 'Text & Content',
    path: '/tools/lorem-ipsum',
    component: 'LoremIpsum'
  },
  
  {
    id: 'translation-tool',
    name: 'Translation Tool',
    description: 'Translate text instantly with auto-detect, swap, and copy support',
    icon: '🌍',
    category: 'Text & Content',
    path: '/tools/translation-tool',
    component: 'TranslationTool'
  },
  

  // Image Tools
  {
    id: 'image-compressor',
    name: 'Image Compressor',
    description: 'Compress images in browser using Canvas API',
    icon: '🗜️',
    category: 'Image Tools',
    path: '/tools/image-compressor',
    component: 'ImageCompressor'
  },
  {
    id: 'image-resizer',
    name: 'Image Resizer',
    description: 'Resize image dimensions with responsive preview',
    icon: '📐',
    category: 'Image Tools',
    path: '/tools/image-resizer',
    component: 'ImageResizer'
  },
  {
    id: 'jpg-png-converter',
    name: 'JPG ⇄ PNG Converter',
    description: 'Convert JPG and PNG formats locally in browser',
    icon: '🖼️',
    category: 'Image Tools',
    path: '/tools/jpg-png-converter',
    component: 'JPGPNGConverter'
  },
  {
    id: 'webp-converter',
    name: 'WebP Converter',
    description: 'Convert to and from WebP format using Canvas',
    icon: '🌐',
    category: 'Image Tools',
    path: '/tools/webp-converter',
    component: 'WebPConverter'
  },
  {
    id: 'image-cropper',
    name: 'Image Cropper',
    description: 'Crop images with pixel-level controls',
    icon: '✂️',
    category: 'Image Tools',
    path: '/tools/image-cropper',
    component: 'ImageCropper'
  },
  {
    id: 'image-rotator',
    name: 'Image Rotator',
    description: 'Rotate images by angle and export quickly',
    icon: '🔄',
    category: 'Image Tools',
    path: '/tools/image-rotator',
    component: 'ImageRotator'
  },
  {
    id: 'image-base64',
    name: 'Image ⇄ Base64',
    description: 'Convert image files to Base64 and back',
    icon: '🔐',
    category: 'Image Tools',
    path: '/tools/image-base64',
    component: 'ImageBase64Tool'
  },

  // PDF Tools
  {
    id: 'merge-pdf',
    name: 'Merge PDF',
    description: 'Merge multiple PDF files into one document',
    icon: '📎',
    category: 'PDF Tools',
    path: '/tools/merge-pdf',
    component: 'MergePDF'
  },
  {
    id: 'split-pdf',
    name: 'Split PDF',
    description: 'Split PDF by selected pages or ranges',
    icon: '✂️',
    category: 'PDF Tools',
    path: '/tools/split-pdf',
    component: 'SplitPDF'
  },
  {
    id: 'compress-pdf',
    name: 'Compress PDF',
    description: 'Optimize PDF size for sharing and web uploads',
    icon: '🗜️',
    category: 'PDF Tools',
    path: '/tools/compress-pdf',
    component: 'CompressPDF'
  },
  {
    id: 'rotate-pdf',
    name: 'Rotate PDF',
    description: 'Rotate PDF pages in browser instantly',
    icon: '🔄',
    category: 'PDF Tools',
    path: '/tools/rotate-pdf',
    component: 'RotatePDF'
  },
  {
    id: 'extract-pdf-pages',
    name: 'Extract PDF Pages',
    description: 'Extract specific PDF pages to a new file',
    icon: '📄',
    category: 'PDF Tools',
    path: '/tools/extract-pdf-pages',
    component: 'ExtractPDFPages'
  },

  // Calculator Tools
  {
    id: 'bmi-calculator',
    name: 'BMI Calculator',
    description: 'Calculate body mass index and health range',
    icon: '⚖️',
    category: 'Calculator Tools',
    path: '/tools/bmi-calculator',
    component: 'BMICalculator'
  },
  {
    id: 'percentage-calculator',
    name: 'Percentage Calculator',
    description: 'Calculate percentages for quick math tasks',
    icon: '📊',
    category: 'Calculator Tools',
    path: '/tools/percentage-calculator',
    component: 'PercentageCalculator'
  },
  {
    id: 'discount-calculator',
    name: 'Discount Calculator',
    description: 'Find final price and savings after discount',
    icon: '🏷️',
    category: 'Calculator Tools',
    path: '/tools/discount-calculator',
    component: 'DiscountCalculator'
  },
  {
    id: 'loan-emi-calculator',
    name: 'Loan EMI Calculator',
    description: 'Estimate monthly EMI for loan repayment',
    icon: '🏦',
    category: 'Calculator Tools',
    path: '/tools/loan-emi-calculator',
    component: 'LoanEMICalculator'
  },
  {
    id: 'vat-calculator',
    name: 'VAT Calculator',
    description: 'Add or remove VAT from prices instantly',
    icon: '🧾',
    category: 'Calculator Tools',
    path: '/tools/vat-calculator',
    component: 'VATCalculator'
  },
  {
    id: 'date-difference-calculator',
    name: 'Date Difference Calculator',
    description: 'Get exact day difference between dates',
    icon: '📅',
    category: 'Calculator Tools',
    path: '/tools/date-difference-calculator',
    component: 'DateDifferenceCalculator'
  },
  {
    id: 'time-duration-calculator',
    name: 'Time Duration Calculator',
    description: 'Calculate time duration between two times',
    icon: '⏱️',
    category: 'Calculator Tools',
    path: '/tools/time-duration-calculator',
    component: 'TimeDurationCalculator'
  },

  // Text Tools
  {
    id: 'remove-duplicate-lines',
    name: 'Remove Duplicate Lines',
    description: 'Remove duplicate lines from text quickly',
    icon: '🧹',
    category: 'Text Tools',
    path: '/tools/remove-duplicate-lines',
    component: 'RemoveDuplicateLines'
  },
  {
    id: 'slug-generator',
    name: 'Slug Generator',
    description: 'Generate SEO-friendly slugs from text',
    icon: '🔗',
    category: 'Text Tools',
    path: '/tools/slug-generator',
    component: 'SlugGenerator'
  },
  {
    id: 'text-sorter',
    name: 'Text Sorter',
    description: 'Sort lines alphabetically in ascending order',
    icon: '↕️',
    category: 'Text Tools',
    path: '/tools/text-sorter',
    component: 'TextSorter'
  },
  {
    id: 'line-break-remover',
    name: 'Line Break Remover',
    description: 'Remove line breaks and normalize spaces',
    icon: '📏',
    category: 'Text Tools',
    path: '/tools/line-break-remover',
    component: 'LineBreakRemover'
  },
  {
    id: 'json-formatter-minifier',
    name: 'JSON Formatter / Minifier',
    description: 'Format and minify JSON with validation',
    icon: '🧩',
    category: 'Text Tools',
    path: '/tools/json-formatter-minifier',
    component: 'JSONFormatterMinifier'
  },
  {
    id: 'base64-tools',
    name: 'Base64 Tools',
    description: 'Encode and decode Base64 text instantly',
    icon: '🔐',
    category: 'Text Tools',
    path: '/tools/base64-tools',
    component: 'Base64Tools'
  },

  // Developer Tools
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    description: 'Format, validate, and beautify JSON data',
    icon: '💾',
    category: 'Developer',
    path: '/tools/json-formatter',
    component: 'JSONFormatter'
  },
  {
    id: 'base64-encoder',
    name: 'Base64 Encoder/Decoder',
    description: 'Encode and decode Base64 strings',
    icon: '🔐',
    category: 'Developer',
    path: '/tools/base64-encoder',
    component: 'Base64Encoder'
  },
  {
    id: 'url-encoder',
    name: 'URL Encoder/Decoder',
    description: 'Encode and decode URLs for web use',
    icon: '🌐',
    category: 'Developer',
    path: '/tools/url-encoder',
    component: 'URLEncoder'
  },
  
  // Utility Tools
  {
    id: 'password-generator',
    name: 'Password Generator',
    description: 'Generate secure random passwords',
    icon: '🔑',
    category: 'Utility',
    path: '/tools/password-generator',
    component: 'PasswordGenerator'
  },
  {
    id: 'random-number',
    name: 'Random Number Generator',
    description: 'Generate random numbers in any range',
    icon: '🎲',
    category: 'Utility',
    path: '/tools/random-number',
    component: 'RandomNumber'
  },
  {
    id: 'age-calculator',
    name: 'Age Calculator',
    description: 'Calculate your exact age with detailed statistics',
    icon: '🎂',
    category: 'Utility',
    path: '/tools/age-calculator',
    component: 'AgeCalculator'
  },
  {
    id: 'wheel-of-fortune',
    name: 'Wheel of Fortune',
    description: 'Spin a customizable wheel to choose an item at random',
    icon: '🎡',
    category: 'Utility',
    path: '/tools/wheel-of-fortune',
    component: 'WheelOfFortune'
  },
  {
    id: 'unit-converter',
    name: 'Unit Converter',
    description: 'Convert between different units of measurement',
    icon: '📏',
    category: 'Utility',
    path: '/tools/unit-converter',
    component: 'UnitConverter'
  }
];

export const getToolById = (id) => {
  return toolsData.find(tool => tool.id === id);
};

export const getToolsByCategory = (category) => {
  if (category === 'All') return toolsData;
  return toolsData.filter(tool => tool.category === category);
};

export const getAllCategories = () => {
  const categories = ['All', ...new Set(toolsData.map(tool => tool.category))];
  return categories;
};
